import { ValidatorChainBuilder } from "helpers/validator";
import {
    IN_ASSORTMENT_FIELD,
    KEY_COLUMN_FIELD,
    READ_ONLY_COLUMNS,
} from "components/product-collection/manage-allocation-dimension/import-door-attributes/constants";
import { IAllocationDimension } from "helpers/allocation-dimension";
import {
    IAttributeData,
    IAttributeDataError,
    RuleType,
} from "components/product-collection/manage-allocation-dimension/import-door-attributes/types";
import {
    NotEmptyRule,
    AttributeAlreadyExistsRule,
    AttributeIsFreeformRule,
    AttributeIsReadonlyRule,
    AttributeValidNameRule,
    BooleanValueRule,
    MaxCustomAttributesRule,
    NoDuplicateDoorsRule,
    OnlyExistingDoorsRule,
    RequiredColumnsRule,
    UseAlternativeIdRule,
    AttributeNameLengthRule,
} from "./validation-rules";

const requiredColumnsForUploadFileSheet = [KEY_COLUMN_FIELD];

type GetAttributesValidatorProps = {
    allocationDimension: IAllocationDimension;
    customAttributesLimit: number;
};

const getAttributesValidator = ({ allocationDimension, customAttributesLimit }: GetAttributesValidatorProps) => {
    return new ValidatorChainBuilder<IAttributeData[], IAttributeDataError>()
        .add(new NotEmptyRule())
        .add(new UseAlternativeIdRule())
        .add(new RequiredColumnsRule(requiredColumnsForUploadFileSheet))
        .add(new OnlyExistingDoorsRule(KEY_COLUMN_FIELD, allocationDimension))
        .add(new NoDuplicateDoorsRule(KEY_COLUMN_FIELD))
        .add(new AttributeAlreadyExistsRule(READ_ONLY_COLUMNS, allocationDimension))
        .add(new AttributeIsReadonlyRule(READ_ONLY_COLUMNS, allocationDimension))
        .add(new AttributeIsFreeformRule(READ_ONLY_COLUMNS, allocationDimension))
        .add(new AttributeValidNameRule(READ_ONLY_COLUMNS, allocationDimension))
        .add(new AttributeNameLengthRule())
        .add(new MaxCustomAttributesRule(READ_ONLY_COLUMNS, allocationDimension, customAttributesLimit))
        .add(new BooleanValueRule(IN_ASSORTMENT_FIELD, RuleType.BooleanInAssortmentValueRule))
        .getFirst();
};

type ValidateDoorAttributesDataProps = {
    data: IAttributeData[];
    allocationDimension: IAllocationDimension;
    customAttributesLimit: number;
};

export const validateDoorAttributesData = ({
    data,
    allocationDimension,
    customAttributesLimit,
}: ValidateDoorAttributesDataProps): IAttributeDataError => {
    const doorGroupingValidator = getAttributesValidator({ allocationDimension, customAttributesLimit });
    return doorGroupingValidator.validate(data, {});
};
